import React from 'react';
import { Route, Switch } from 'react-router-dom';
import DynamicLayout from './DynamicLayout';
import Blog from './Blog';
import AppPage from '../components/AppPage';
import CheckoutPage from '../components/CheckoutPage';
import CreationFormWidget from './Widgets/CreationForm';

const dynamicLayoutFactory = (pageId, analyticsContext = 'Misc') => () => (
  <DynamicLayout pageId={pageId} analyticsContext={analyticsContext} />
);

const checkoutLayoutFactory = (pageId, analyticsContext = 'Checkout') => () => (
  <CheckoutPage>
    {dynamicLayoutFactory(pageId, analyticsContext)()}
  </CheckoutPage>
);

export default (
  <Switch>
    <Route
      exact
      path="/:country?/widgets/product-creation-form/:productSlug"
      component={CreationFormWidget}
    />

    <Route
      exact
      path="/:country?/checkout-v2/address"
      render={checkoutLayoutFactory('shipping-details', 'Shipping Details')}
    />
    <Route
      exact
      path="/:country?/checkout-v2/delivery"
      render={checkoutLayoutFactory('shipping-methods', 'Shipping Methods')}
    />
    <Route
      exact
      path="/:country?/checkout-v2/payment"
      render={checkoutLayoutFactory('payments-methods', 'Payment Methods')}
    />
    <Route
      exact
      path="/:country?/checkout-v2/amazon"
      render={checkoutLayoutFactory('amazon-checkout', 'Amazon Checkout')}
    />

    <AppPage>
      <Switch>
        <Route
          path="/:country?/blog"
          component={Blog}
        />
        <Route
          exact
          path="/:country?/landing-pages/personalized-products/product/:slug"
          render={dynamicLayoutFactory('product-variant', 'Product Page')}
        />
        <Route
          exact
          path="/:country?/landing-pages/personalized-products/:slug"
          render={dynamicLayoutFactory('range-variant', 'Range')}
        />
        <Route
          exact
          path="/:country?/landing-pages/:slug"
          render={dynamicLayoutFactory('homepage-variant', 'Homepage')}
        />
        <Route
          exact
          path="/:country?/personalized-products/:productSlug/options/:itemId"
          render={dynamicLayoutFactory('cart-edit-options', 'Cart Edit Options')}
        />
        <Route
          exact
          path="/:country?/personalized-products/:productSlug/options"
          render={dynamicLayoutFactory('options', 'Options')}
        />
        <Route
          exact
          path="/:country?/personalized-products/:productSlug/preview/:orderNumber/:itemId"
          render={dynamicLayoutFactory('order-edit-item', 'Order Edit Item')}
        />
        <Route
          exact
          path="/:country?/personalized-products/:productSlug/preview/:itemId"
          render={dynamicLayoutFactory('cart-edit-item', 'Cart Edit Item')}
        />
        <Route
          exact
          path="/:country?/personalized-products/:productSlug/preview"
          render={dynamicLayoutFactory('canvas', 'Creation Canvas')}
        />
        <Route
          exact
          path="/:country?/personalized-products/:productSlug"
          render={dynamicLayoutFactory('product', 'Product Page')}
        />
        <Route
          exact
          path="/:country?/personalized-products"
          render={dynamicLayoutFactory('range', 'Range')}
        />
        <Route
          exact
          path="/:country?/choose-your-country"
          render={dynamicLayoutFactory('choose-your-country', 'Choose Country')}
        />
        <Route
          exact
          path="/:country?/login"
          render={dynamicLayoutFactory('login', 'Login')}
        />
        <Route
          exact
          path="/:country?/signup/existing-user"
          render={dynamicLayoutFactory('signup-existing-user', 'Signup Existing User Error')}
        />
        <Route
          exact
          path="/:country?/signup"
          render={dynamicLayoutFactory('signup', 'Signup')}
        />
        <Route
          exact
          path="/:country?/resend-email/:user_id"
          render={dynamicLayoutFactory('resend-email', 'Resend Email')}
        />
        <Route
          exact
          path="/:country?/account/profile"
          render={dynamicLayoutFactory('orders', 'Account')}
        />
        <Route
          exact
          path="/:country?/account/credit"
          render={dynamicLayoutFactory('account-credit', 'Account Credit')}
        />
        <Route
          exact
          path="/:country?/account/offers"
          render={dynamicLayoutFactory('account-offers', 'Account Offers')}
        />
        <Route
          exact
          path="/:country?/account"
          render={dynamicLayoutFactory('orders', 'Orders')}
        />
        <Route
          exact
          path="/:country?/orders/:orderNumber"
          render={dynamicLayoutFactory('order-details', 'Order Details')}
        />
        <Route
          exact
          path="/:country?/orders"
          render={dynamicLayoutFactory('orders', 'Orders')}
        />
        <Route
          exact
          path="/:country?/pages/:slug"
          render={dynamicLayoutFactory('pages', 'Static Pages')}
        />
        <Route
          exact
          path="/:country?/offers/:slug"
          render={dynamicLayoutFactory('offers-variant', 'Offers')}
        />
        <Route
          exact
          path="/:country?/offers"
          render={dynamicLayoutFactory('offers', 'Offers')}
        />
        <Route
          exact
          path="/:country?/forgot-password"
          render={dynamicLayoutFactory('forgot-password', 'Forgot Password')}
        />
        <Route
          exact
          path="/:country?/confirm"
          render={dynamicLayoutFactory('confirm', 'Confirm')}
        />
        <Route
          exact
          path="/:country?/cart"
          render={dynamicLayoutFactory('cart', 'Cart')}
        />
        <Route
          exact
          path="/:country?"
          render={dynamicLayoutFactory('homepage', 'Homepage')}
        />
      </Switch>
    </AppPage>
  </Switch>
);



// WEBPACK FOOTER //
// ./src/client/js/view/routes/routes.js